import { defineMessages } from 'react-intl';

const messages = defineMessages({
  expiration: {
    id: 'App.CreditCriminalStatusScreening.AdverseActionLetterModal.Expiration',
    defaultMessage: 'This offer expires in {adverseActionDeadlineDays} day(s)',
  },
});

export default messages;
